module.exports = {"440311001":"光明街道","440311002":"公明街道","440311003":"新湖街道","440311004":"凤凰街道","440311005":"玉塘街道","440311006":"马田街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440311.json
// module id = 2100
// module chunks = 0